import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetailsBaseComponent } from '../../../../../core/base/components/details-base/details-base.component';
import { ContractService } from '../contract.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../../core/services/auth.service';
import { Link } from '../../../../../../@vex/interfaces/link.interface';
import { ContractModel } from '../../../../../core/models/contract.model';
import { TicketStatusEnum } from '../../../../../core/enums/ticketStatusEnum';
import { ContractStatusEnum, contractStatusTranslation } from '../../../../../core/enums/contract-status.enum';
import { OrderStatus } from '../../../../../core/enums/order-status.enum';
import { Subscription } from 'rxjs';
import { DialogConfirmComponent } from '../../../../../../@vex/components/dialog-confirm/dialog-confirm.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import moment from 'moment';
import { QuotesService } from '../../../achat/quotes/quotes.service';
import { SnackbarService } from '../../../../../core/services/snackbar.service';
import { ContractHotTopicCreateUpdateDeleteComponent } from '../../../administrative/hot-topic/contract/contract-hot-topic-create-update-delete/contract-hot-topic-create-update-delete.component';
import { CrudModeEnum } from '../../../../../core/base/enum/crud-mode.enum';
import { PermissionMessageService } from '../../../../../core/services/permission-message.service';
import { ENUM_PERMISSIONS } from '../../../../../core/enums/permission.enum';

@Component({
  selector: 'vex-contract-details',
  templateUrl: './contract-details.component.html',
  styleUrls: ['./contract-details.component.scss'],
})
export class ContractDetailsComponent extends DetailsBaseComponent<ContractModel> implements OnInit, OnDestroy {
  subscription = new Subscription();
  isValidable = false;
  contractStatus: ContractStatusEnum;
  creationStep: number;
  contractStatusEnum = ContractStatusEnum;
  contract: ContractModel;
  contractStatusTranslation = contractStatusTranslation;
  defaultTabs: Link[] = [
    {
      label: 'INFORMATIONS',
      route: './',
      routerLinkActiveOptions: { exact: true },
      permission: ENUM_PERMISSIONS.READ_CONTRACT_INFORMATION,
    },
    {
      label: 'PÉRIMÈTRE',
      route: './perimeter',
      permission: ENUM_PERMISSIONS.READ_CONTRACT_PERIMETER,
      //  additionalCondition: this.authService.currentUserValue().contactType.some(x => this.authService.checkCurrentIsPredik()),
      routerLinkActiveOptions: { exact: true },
    },
    {
      label: 'CGA',
      route: './cga',
      permission: ENUM_PERMISSIONS.READ_CONTRACT_CGA,
      routerLinkActiveOptions: { exact: true },
    },
    {
      label: 'CATALOGUE FOURNISSEUR',
      route: './catalog',
      permission: ENUM_PERMISSIONS.READ_CONTRACT_CATALOG,
      routerLinkActiveOptions: { exact: true },
    },
    {
      label: 'CATALOGUE FOURNISSEUR',
      route: './internalCatalog',
      permission: ENUM_PERMISSIONS.READ_CONTRACT_CATALOG,
      routerLinkActiveOptions: { exact: true },
    },
    {
      label: 'PANIER CONTRAT',
      route: './basket-contract',
      permission: ENUM_PERMISSIONS.READ_CONTRACT_BASKET,
      routerLinkActiveOptions: { exact: true },
    },
  ];
  protected readonly TicketStatusEnum = TicketStatusEnum;
  protected readonly OrderStatus = OrderStatus;

  constructor(
    public service: ContractService,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private router: Router,
    private snackbarService: SnackbarService,
    private dialog: MatDialog,
    private quoteService: QuotesService,
    private permissionMessageService: PermissionMessageService,
  ) {
    super(service, activatedRoute, authService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    const sub = this.service.entity$.subscribe((contract: ContractModel) => {
      this.contract = contract;
      this.contractStatus = contract?.status;
      this.creationStep = contract?.creationStep;

      const isPerimeterDisabled = contract?.creationStep < 2;
      const isCgaDisabled = contract?.creationStep < 3;
      const isCatalogDisabled = contract?.creationStep < 4;

      // Toujours repartir d'une liste propre
      this.tabs = [
        {
          label: 'INFORMATIONS',
          route: './',
          routerLinkActiveOptions: { exact: true },
          permission: ENUM_PERMISSIONS.READ_CONTRACT_INFORMATION,
        },
        {
          label: 'PÉRIMÈTRE',
          route: './perimeter',
          routerLinkActiveOptions: { exact: true },
          permission: ENUM_PERMISSIONS.READ_CONTRACT_PERIMETER,
        },
        {
          label: 'CGA',
          route: './cga',
          routerLinkActiveOptions: { exact: true },
          permission: ENUM_PERMISSIONS.READ_CONTRACT_CGA,
        },
        {
          label: 'CATALOGUE FOURNISSEUR',
          route: './catalog',
          routerLinkActiveOptions: { exact: true },
          permission: ENUM_PERMISSIONS.READ_CONTRACT_CATALOG,
        },
        {
          label: 'PANIER CONTRAT',
          route: './basket-contract',
          routerLinkActiveOptions: { exact: true },
          permission: ENUM_PERMISSIONS.READ_CONTRACT_BASKET,
        },
      ];

      // Appliquer désactivation
      this.tabs = this.tabs.map(tab => {
        if (tab.label === 'PÉRIMÈTRE') {
          tab.disabled = isPerimeterDisabled;
        }
        if (tab.label === 'CGA') {
          tab.disabled = isCgaDisabled;
        }
        if (tab.label === 'CATALOGUE FOURNISSEUR') {
          tab.disabled = isCatalogDisabled;
        }
        if (tab.label === 'PANIER CONTRAT') {
          tab.disabled = isCatalogDisabled;
        }
        return tab;
      });

      // Supprimer onglet PÉRIMÈTRE si supportEstablishment

      console.log('contract', contract);
      if (!!contract?.supportEstablishment) {
        this.tabs = this.tabs.filter(tab => tab.label !== 'PÉRIMÈTRE');
        this.tabs = this.tabs.map(tab =>
          tab.label === 'CATALOGUE FOURNISSEUR' ? { ...tab, route: './internalCatalog' } : tab,
        );
      }

      // Valider état final
      this.isValidable = contract?.creationStep >= 4;
    });

    this.subscription.add(sub);

    const subEligibleForValidation = this.service.isValidable$.subscribe((isEligibleForValidation: boolean) => {
      this.isValidable = isEligibleForValidation;
    });
    this.subscription.add(subEligibleForValidation);
  }

  // trackBy pour le template
  trackByLabel(index: number, tab: Link): string {
    return tab.label;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.subscription.unsubscribe();
  }

  async validatesContract() {
    const entity = await this.service.entity;

    // Validation directe sans modale
    this.loading = true;
    this.service.validatesContract(entity._id, entity, []).subscribe(
      result => {
        this.snackbarService.success("L'engagement a été validé avec succès");
        this.addTopicToContract();
      },
      error => {
        this.loading = false;
        if (error?.error?.statusCode === 5509) {
          this.snackbarService.danger(error.error.message);
        } else {
          this.snackbarService.danger("Erreur lors de la validation de l'engagement");
        }
      },
    );
  }

  async addTopicToContract() {
    // Créer une actualité depuis la fiche contrat = même action que depuis l'écran Actualités.
    if (this.permissionMessageService.blockIfMissingPermission(ENUM_PERMISSIONS.CREATE_HOTTOPIC)) {
      return;
    }
    const entity = await this.service.entity;
    this.dialog
      .open(ContractHotTopicCreateUpdateDeleteComponent, {
        data: {
          contractId: entity._id,
          mode: CrudModeEnum.Create,
        },
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          this.snackbarService.success("L'actualité a été ajouté avec succès");
        }
      });
  }

  checkStartDateValidationIsPassed(startValidityDate: Date): boolean {
    const today = moment();
    const startDate = moment(startValidityDate);
    return today.isSameOrAfter(startDate, 'day');
  }

  async invalidateContract() {
    const entity = await this.service.entity;
    const hasRecurringBasket = entity.recurringBasket?.length > 0;
    const defaultMessage = `Êtes-vous certain(e) de vouloir dévalider l’engagement ?`;
    const recurringBasketMessage = `Êtes-vous certain(e) de vouloir dévalider l’engagement ? Les paniers contrats seront désactivés.`;

    this.dialog
      .open(DialogConfirmComponent, {
        data: {
          title: 'Dévalidation du contrat',
          description: hasRecurringBasket ? recurringBasketMessage : defaultMessage,
          cancelText: 'Annuler',
          validText: 'Dévalider',
          call$: this.service.invalidateContract(entity._id),
          additionalIcon: 'warning',
        },
      })
      .afterClosed()
      .subscribe(result => {});
  }

  async deleteDraft() {
    const entity = await this.service.entity;
    const dialogRef = this.dialog
      .open(DialogConfirmComponent, {
        data: {
          title: 'Suppression du brouillon',
          description: entity.quoteId
            ? 'Une demande de devis est liée à cet engagement; Êtes-vous certain(e) de vouloir supprimer le brouillon ?'
            : 'Êtes-vous sûr de vouloir supprimer ce brouillon ?',
          cancelText: 'Annuler',
          validText: 'Valider',
          call$: this.service.delete(entity),
        },
      })
      .afterClosed()
      .subscribe(result => {
        this.router.navigateByUrl('/management/engagement').then();
      });
  }
}
